<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Notification Breakdown
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div style="width:100%; background-color: rgb(240,240,240)">
                            <v-btn round color="primary" dark v-for="(value,facet) in activeFacets"  v-bind:key="facet" @click="clearFacet(facet)">
                                {{facets[facet]}} : {{value}} <v-icon class="ml-2">fa-times-circle</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 v-for="facetGraph in facetGraphs" v-bind:key="facetGraph.facet" v-bind:class="[facetGraph['flex-class'], 'md4']" >
                        <div class="pl-3 pr-3 pt-3">
                            <v-autocomplete
                                    solo-inverted
                                    :items="facetOptions[facetGraph.facet]"
                                    :label="facetGraph.label"
                                    @change="selectFacet($event, facetGraph.facet)"
                            ></v-autocomplete>
                        </div>

                        <vue-plotly disable-responsive :data="facetGraph.data" :layout="facetGraph.layout" :options="{}" @click="handleClick"></vue-plotly>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                        <v-data-table
                                :headers="headers"
                                disable-initial-sort
                                :items="items"
                                :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)">{{ props.item.title }}</td>
                                <td class="text-xs-left">{{ props.item.equip }}</td>
                                <td class="text-xs-left" >{{ props.item.equipType }}</td>
                                <td class="text-xs-left" >{{ props.item.topic }}</td>
                                <td class="text-xs-left" >{{ props.item.floor }}</td>
                                <td class="text-xs-left caption">{{ props.item.description }}</td>
                                <td class="text-xs-left" >
                                    <ul v-if="props.item.recommendedActions">
                                        <li v-for="i in props.item.recommendedActions.split('\n')">{{i}}</li>
                                    </ul>
                                </td>
                                <td class="text-xs-left">{{props.item.startDate}}</td>
                                <td class="text-xs-left">{{props.item.endDate}}</td>
                                <td class="text-xs-left">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                <v-icon color="warning">fa-bell</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                            </v-btn>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                </td>
                                <td class="justify-center layout px-0">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>Add maintenance record </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>View chart </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    @click="jumpToMR(props.item)"
                                            >
                                                fa-clipboard-list
                                            </v-icon>
                                        </template>
                                        <span>View maintenanace records for this period </span>
                                    </v-tooltip>


                                </td>
                            </template>
                        </v-data-table>
                        <v-dialog v-model="dialog" max-width="800">
                            <v-card>
                                <v-card-title class="primary white--text title">
                                    {{currentItem.title}}
                                </v-card-title>
                                <v-card-text>
                                    <p class="headline">
                                        Equipment : {{currentItem.equip}}
                                    </p>
                                    <p>
                                        {{currentItem.description}}
                                    </p>
                                    <p>
                                        Occured between {{currentItem.startDate.replace('T',' ')}} and
                                        {{currentItem.endDate.replace('T',' ')}}
                                    </p>
                                </v-card-text>
                                <v-divider v-if="currentItem.recommendedActions"></v-divider>
                                <v-card-text v-if="currentItem.recommendedActions">
                                    <p class="headline">
                                        <v-icon>fa-shoe-prints</v-icon>
                                        Recommended Actions
                                    </p>
                                    <ul v-if="currentItem.recommendedActions">
                                        <li v-for="i in currentItem.recommendedActions.split('\n')">
                                            {{i}}
                                        </li>
                                    </ul>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="primary" round @click="callMaintenanceDialog(currentItem)">
                                        <v-icon class="mr-2">fa-notes-medical</v-icon>
                                        Add Maintenance Record
                                    </v-btn>
                                    <v-btn class="accent" round @click="jumpToLink(currentItem)">
                                        <v-icon class="mr-2">fa-chart-line</v-icon>
                                        View Chart
                                    </v-btn>
                                    <v-btn class="accent" round @click="dialog = false">
                                        Cancel
                                    </v-btn>
                                </v-card-actions>
                                <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {getNotification} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import FaultRecordDialog from '../components/FaultRecordDialog'
    import SeverityChip from '../components/SeverityChip'
    import {putNotification} from '../helper'
    import {exportCSV} from '../tocsv'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    import _ from 'lodash'

    export default {
        name: 'NotificationBreakdown',
        components: {VuePlotly,SeverityChip, FaultRecordDialog,DateRangeSelector},
        data() {
            return {
                activeFacets:{},
                facetOptions:{},
                dialog: false,
                items:null,
                maintenanceDialog: false,
                maintenanceItem: null,
                dateRange:  {start:moment().subtract(30, "days").format("YYYY-MM-DD"),end:moment().format("YYYY-MM-DD")},
                search: '',
                facets: {
                    "floor": "Floor",
                    "equipment_name": "Equipment",
                    "severity": "Severity",
                    "equipment_type": "Equipment Type",
                    "title": "Issue",
                    "topic": "Topic",
                },
                currentItem: {
                    icon: 'fa-bell',
                    title: 'Condenser Cleaning Required in Chiller 1',
                    equip: 'Chiller 1',
                    startDate: '',
                    endDate: '',
                    to: {
                        path: '/sensors',
                        query: {
                            onOnly: true,
                            variableX: 'Cond_Approach',
                            variableY: 'Cond_Approach',
                            rangeStart: '2018-01-01',
                            rangeEnd: '2018-06-30',
                            equipment: 'Chiller 1'
                        }
                    },
                    description: "Condenser Approach High in Chiller 1",
                    recommendedActions: [
                        'Clean Condenser Tubes',
                        'Check Condenser Water Pumps',
                    ].join('\n')
                },
                facetGraphs:[],
                loading: true,
                rawNotifs:null,
                notifs:null,
            }
        },
        computed: {
            headers() {
                    return [
                        {
                            text: 'Alerts',
                            align: 'left',
                            sortable: true,
                            value: 'title'
                        },
                        {text: 'Equipment', value: 'equip'},
                        {text: 'Equipment Type', value: 'equipType',sortable: true},
                        {text: 'Topic', value: 'topic',sortable: true},
                        {text: 'Floor', value: 'floor',sortable: true},
                        {text: 'Description', value: 'description'},
                        {text: 'Recommended Actions', value: 'recommendedActions'},
                        {text: 'Start Date', value: 'startDate'},
                        {text: 'End Date', value: 'endDate'},
                        {text: 'Severity', value: 'severity'},
                        {text: 'Acknowledged', value: 'acknowledged'},
                        {text: 'Actions', value: 'name', sortable: false}
                    ]
            }
        },
        methods: {
            selectFacet(event,facet){
                this.activeFacets[facet]=event
                this.updateQueryString()
                this.refineNotifs()
            },
            handleDateChange(){
                this.updateQueryString()
                this.getData()
            },
            updateQueryString () {
                if(this.$router.currentRoute.name==="notification-breakdown"){
                    let filters={...this.activeFacets}
                    filters.rangeStart=this.dateRange.start
                    filters.rangeEnd=this.dateRange.end
                    this.$router.replace({
                        path: '/notification-breakdown',
                        query: filters
                    }).catch(err => {})
                }
            },
            async trigger(id, state) {
                await putNotification(
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'notification_id': id,
                        'show_flag': state
                    }
                )
            },
            exportNotification() {
                exportCSV(this.items)
            },
            getMaintenanceItem(item) {
                let itemUrlObj=this.getItemUrl(item)
                return {
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    equipment: item['equip'],
                    maintenance_date_from: item['startDate'],
                    maintenance_date_to: item['endDate'],
                    severity: item['severity'],
                    maintenance_text: 'Recommended Actions: \n\n' + item['recommendedActions'],
                    maintenance_label: item['description'],
                    url: this.$router.resolve(itemUrlObj).href,
                    notification_id: item['notification_id'],
                    is_fixed: false,
                    maintenance_id: null
                }
            },
            callMaintenanceDialog(item, dialogOpen = true) {
                this.maintenanceItem = this.getMaintenanceItem(item)
                this.maintenanceDialog = dialogOpen
            },
            callDialog(item) {
                this.dialog = true
                this.currentItem = item
            },
            getItemUrl(item){
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equip
                        }
                    }
                } else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equip
                        }
                    }
                }
                return output
            },
            jumpToLink(item) {
                let output=this.getItemUrl(item)
                this.$router.push(output)
                // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
                // this.$router.push(item.to)
            },
            jumpToMR(item) {
                this.$router.push({
                    path:"/maintenancerecord",
                    query:{
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                    }
                })

            },
            handleClick(data){
                let facet=data.points[0].fullData.name
                let value=data.points[0].y
                this.activeFacets[facet]=value
                this.updateQueryString()
                this.refineNotifs()
            },
            clearFacet(facet){
                delete(this.activeFacets[facet])
                this.updateQueryString()
                this.refineNotifs()
            },
            getData() {
                let me = this;
                me.loading = true
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:[this.dateRange.start,this.dateRange.end]
                }).then(function(notifResult) {
                    me.rawNotifs=notifResult.result
                    me.refineNotifs()
                })
            },
            refineNotifs(){
                let me=this
                me.loading = true
                let notifs=[...me.rawNotifs]
                for (let activeFacet in me.activeFacets){
                    if(activeFacet==="floor"){
                        notifs=notifs.filter(x=>x[activeFacet].startsWith(me.activeFacets[activeFacet]))
                    } else {
                        notifs=notifs.filter(x=>x[activeFacet]===me.activeFacets[activeFacet])
                    }
                }
                let facetGraphs=[]
                let facetOptions={}
                for (let facet in me.facets){
                    if(me.activeFacets[facet]&&facet!=="floor"){
                        continue
                    }
                    let facetObj={}
                    for (let notif of notifs){
                        if(facet==="floor"){
                            if(notif[facet]&&notif[facet]!==""){
                                let subfacets=notif[facet].split(">")
                                if(subfacets.length>1){

                                        let prev = [...subfacets]
                                        subfacets = subfacets.map((value, index) => {
                                            if (index === 0) {
                                                return value
                                            } else {
                                                return (prev.slice(0, index).join(">") + ">" + value)
                                            }
                                        })

                                }
                                for (let subfacet of subfacets){
                                    if(subfacet!==me.activeFacets[facet]){
                                        if (!facetObj[subfacet]) {
                                            facetObj[subfacet] = 1;
                                        } else {
                                            facetObj[subfacet] += 1;
                                        }
                                    }
                                }
                            }
                        } else {
                            if (!facetObj[notif[facet]]) {
                                facetObj[notif[facet]] = 1;
                            } else {
                                facetObj[notif[facet]] += 1;
                            }
                        }
                    }
                    if(Object.keys(facetObj).length<=1){
                        continue
                    }

                    let sorted = Object.keys(facetObj).sort(function(a,b){return facetObj[b]-facetObj[a]})
                    facetOptions[facet]=[...sorted];
                    if(facet==="floor"&&!me.activeFacets[facet]){
                        sorted=sorted.filter(x=>x.indexOf('>')<0)
                    }
                    let top10=sorted.slice(0,10);
                    let top10Scores=[]
                    for(let top of top10){
                        top10Scores.push(facetObj[top])
                    }
                    let facetDef={
                        "facet":facet,
                        "label":me.facets[facet],
                        "data":[{
                            type: 'bar',
                            name:facet,
                            x: top10Scores.reverse(),
                            y: top10.reverse(),
                            orientation: 'h',
                        }],
                        "layout":{
                            title:me.facets[facet],
                            margin:{
                                l:200
                            }
                        }
                    }
                    if(facet=='title'){
                        facetDef['flex-class']='md8'
                        facetDef.layout.margin={
                            l:600
                        }
                    }

                    facetGraphs.push(facetDef)
                }
                me.facetOptions=facetOptions
                let items=[]
                for (let i in notifs) {
                    items.push({
                        icon: 'fa-bell',
                        alertType: notifs[i]['model'],
                        title: notifs[i]['title'],
                        equip: notifs[i]['equipment_name'],
                        equipType: notifs[i]['equipment_type'],
                        floor: notifs[i]['floor'],
                        startDate: notifs[i]['start_date'],
                        endDate: notifs[i]['end_date'],
                        topic: notifs[i]['topic'],
                        occurredTimes: notifs[i]['occurred_times'],
                        to: notifs[i]['to'],
                        description: notifs[i]['description'],
                        recommendedActions: notifs[i]['recommended_actions'],
                        severity: notifs[i]['severity'],
                        notification_id: notifs[i]['notification_id'],
                        acknowledged: notifs[i]['acknowledged'],
                    })
                }
                me.items=items= _.sortBy(items, ['endDate']).reverse()
                me.facetGraphs=facetGraphs
                me.loading = false
            }
        },
        mounted() {

            this.getData();
        },

        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
                delete(preconf.rangeStart)
                delete(preconf.rangeEnd)
            } else if(maxDate){
                this.dateRange={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
            if(Object.keys(preconf).length>0){
                this.activeFacets=preconf
            }
        }


    }
</script>
